import { lazy } from "react";

// route //////////////
export const masterRoute = { path: "/setting", name: "menu.master", icon: "settings" };
export const mBankAccRoute = { path: `${masterRoute.path}/bankAccount`, name: "master_bankaccount." };
export const mCategoryRoute = { path: `${masterRoute.path}/category`, name: "common.category" };
export const mCourierRoute = { path: `${masterRoute.path}/courier`, name: "common.courier" };
export const mCustomerRoute = { path: `${masterRoute.path}/customer`, name: "common.customer" };
export const mSupplierRoute = { path: `${masterRoute.path}/supplier`, name: "common.supplier" };
export const mConvertionRoute = { path: `${masterRoute.path}/conversion`, name: "master_convertion." };
export const mFinanceRoute = { path: `${masterRoute.path}/fiance`, name: "master_finance." };
export const mPaymentMethodRoute = { path: `${masterRoute.path}/paymethod`, name: "master_payment_method." };
export const mTNCRoute = { path: `${masterRoute.path}/termAndCondition`, name: `master_tncsetting.` };
export const mUnitRoute = { path: `${masterRoute.path}/unit`, name: "common.unit" };
export const mPriceTierRoute = { path: `${masterRoute.path}/price_tier`, name: "master_price_tier." };
export const mSalesRoute = { path: `${masterRoute.path}/sales`, name: "master_sales." };

// warehouse
export const mWarehouseRoute = { path: `${masterRoute.path}/warehouse`, name: "master_whssetting." };
export const mWarehouseAddressCreateRoute = { path: `${mWarehouseRoute.path}/create`, name: "master_whssetting.add" };
export const mWarehouseAddressEditRoute = { path: `${mWarehouseRoute.path}/edit`, name: "master_whssetting.edit" };
export const mWarehouseStorageRoute = { path: `${mWarehouseRoute.path}/storage`, name: "master_storage." };

// user
export const mUserRoute = { path: `${masterRoute.path}/user`, name: "master_user." };
export const mUserCreateRoute = { path: `${mUserRoute.path}/create`, name: "master_user.add" };
export const mUserEditRoute = { path: `${mUserRoute.path}/edit`, name: "master_user.edit" };

// goods
export const mGoodsRoute = { path: `${masterRoute.path}/goods`, name: "common.goods" };
export const mGoodsBarcodeRoute = { path: `${mGoodsRoute.path}/barcode`, name: "master_goods.barcode" };
export const mGoodsCreateRoute = { path: `${mGoodsRoute.path}/create`, name: `master_goods.add` };
export const mGoodsEditRoute = { path: `${mGoodsRoute.path}/edit`, name: "master_goods.edit" };
export const mGoodsPriceRoute = { path: `${mGoodsRoute.path}/price`, name: "master_goods.price" };
export const mGoodsUploadRoute = { path: `${mGoodsRoute.path}/upload`, name: "master_goods.upload" };
export const mGoodsViewRoute = { path: `${mGoodsRoute.path}/view`, name: "master_goods.view" };

// grouping
export const mGroupingRoute = { path: `${masterRoute.path}/grouping`, name: "menu.groups" };
export const mGroupingCreateRoute = { path: `${mGroupingRoute.path}/create`, name: "master_groups.add" };
export const mGroupingEditRoute = { path: `${mGroupingRoute.path}/edit`, name: "master_groups.edit" };

// profile
export const mProfileRoute = { path: `${masterRoute.path}/profile`, name: "common.profile" };
export const mProfileCreateRoute = { path: `${mProfileRoute.path}/create`, name: "master_profile.add" };
export const mProfileEditRoute = { path: `${mProfileRoute.path}/edit`, name: "master_profile.edit" };

//process
export const mProcessRoute = { path: `${masterRoute.path}/production`, name: "master_process." };
export const mProcessCreateRoute = { path: `${mProcessRoute.path}/add`, name: "master_process.add" };
export const mProcessEditRoute = { path: `${mProcessRoute.path}/edit`, name: "master_process.edit" };

//attribute
export const mAttributeRoute = { path: `${masterRoute.path}/attribute`, name: "master_attribute." };

// item tag
export const mItemTagRoute = { path: `${masterRoute.path}/itemtag`, name: "master_itemtag." };

// end route /////////////////////

// component
const Master = lazy(() => import("../page/master/Master"));
const MUser = lazy(() => import("../page/master/user/MasterUser"));
const MUserForm = lazy(() => import("../page/master/user/form/MasterUserForm"));
const MUnitCategory = lazy(() => import("../page/master/unit_category/MasterUnitCategory"));
const MSupplier = lazy(() => import("../page/master/supplier/MasterSupplier"));
const MCustomer = lazy(() => import("../page/master/customer/MasterCustomer"));
const MSales = lazy(() => import("../page/master/sales/MasterSales"));

const MGoods = lazy(() => import("../page/master/goods/MasterGoods"));
const MGoodsView = lazy(() => import("../page/master/goods/detail/MasterGoodsView"));
const MGoodsForm = lazy(() => import("../page/master/goods/form/MasterGoodsForm"));
const MGoodsUploadForm = lazy(() => import("../page/master/goods/MasterGoodsUploadForm"));
const MGoodsPriceForm = lazy(() => import("../page/master/goods/price/MasterGoodsPrice"));
const MGoodsBarcodeRoute = lazy(() => import("../page/master/goods/barcode/MasterGoodsBarcode"));

const MProfile = lazy(() => import("../page/master/profile/MasterProfile"));
const MProfileForm = lazy(() => import("../page/master/profile/form/MasterProfileForm"));

// const MGrouping = lazy(() => import("../page/master/grouping/MasterGrouping"));
// const MGroupingForm = lazy(() => import("../page/master/grouping/form/MasterGroupingForm"));

const MConversion = lazy(() => import("../page/master/conversion/MasterConversion"));
const MTNCSetting = lazy(() => import("../page/master/tnc_setting/MasterTNCSetting"));
const MFinanceRoom = lazy(() => import("../page/master/finance/MasterFinance"));
const MBankAccount = lazy(() => import("../page/master/bank_account/MasterBankAccount"));
const MPaymentMethod = lazy(() => import("../page/master/payment_method/MasterPaymentMethod"));

const MProcess = lazy(() => import("../page/master/process/MasterProcess"));
const MProcessForm = lazy(() => import("../page/master/process/form/MasterProcessForm"));
const MCourier = lazy(() => import("../page/master/courier/MasterCourier"))
const MAttribute = lazy(() => import("../page/master/attribute/MasterAttribute"))
const MItemTag = lazy(() => import("../page/master/item_tag/MasterItemTag"))
const MPriceTier = lazy(() => import("../page/master/price_tier/MasterPriceTier"))

const MWarehouse = lazy(() => import("../page/master/warehouse/MasterWarehouse"));
const MWarehouseAddressForm = lazy(() => import("../page/master/warehouse/MasterWarehouseAddressForm"));
const MWarehouseStorage = lazy(() => import("../page/master/warehouse/storage/MasterWarehouseStorage"));
// end component

export const masterListRoutes = [
    mUserRoute,
    mCourierRoute,
    mSalesRoute,
    mCustomerRoute,
    mSupplierRoute,
    mGoodsRoute,
    mProfileRoute,
    // mGroupingRoute,
    mConvertionRoute,
    mTNCRoute,
    mBankAccRoute,
    mPaymentMethodRoute,
    mProcessRoute,
    // mPOFeeRoute,
    mFinanceRoute,
    mWarehouseRoute,
    mUnitRoute,
    mCategoryRoute,
    mAttributeRoute,
    mItemTagRoute,
    mPriceTierRoute,
];

export const masterMutationRoute = [
    mGoodsCreateRoute, mGoodsEditRoute, mGoodsUploadRoute, mGoodsPriceRoute, mGoodsBarcodeRoute, mGoodsViewRoute,
    mGroupingCreateRoute, mGroupingEditRoute,
    mProfileCreateRoute, mProfileEditRoute,
    mProcessCreateRoute, mProcessEditRoute,
    mUserCreateRoute, mUserEditRoute,
    mWarehouseAddressCreateRoute, mWarehouseAddressEditRoute,
    mWarehouseStorageRoute,
]

export const masterRoutes = {
    element: <Master />,
    children: [
        { ...mAttributeRoute, element: <MAttribute /> },
        { ...mItemTagRoute, element: <MItemTag /> },
        { ...mUserRoute, element: <MUser /> },
        { ...mCourierRoute, element: <MCourier /> },
        { ...mSalesRoute, element: <MSales /> },
        { ...mUserCreateRoute, element: <MUserForm type="add" /> },
        { ...mUserEditRoute, element: <MUserForm type="edit" /> },
        { ...mUnitRoute, element: <MUnitCategory type="unit" /> },
        { ...mCategoryRoute, element: <MUnitCategory type="category" /> },
        { ...mGoodsRoute, element: <MGoods /> },
        { ...mGoodsViewRoute, element: <MGoodsView /> },
        { ...mGoodsCreateRoute, element: <MGoodsForm type="add" /> },
        { ...mGoodsEditRoute, element: <MGoodsForm type="edit" /> },
        { ...mGoodsUploadRoute, element: <MGoodsUploadForm /> },
        { ...mGoodsPriceRoute, element: <MGoodsPriceForm /> },
        { ...mGoodsBarcodeRoute, element: <MGoodsBarcodeRoute /> },
        { ...mCustomerRoute, element: <MCustomer /> },
        { ...mSupplierRoute, element: <MSupplier /> },
        { ...mProfileRoute, element: <MProfile /> },
        { ...mProfileCreateRoute, element: <MProfileForm type="add" /> },
        { ...mProfileEditRoute, element: <MProfileForm type="edit" /> },
        // { ...mGroupingRoute, element: <MGrouping /> },
        // { ...mGroupingCreateRoute, element: <MGroupingForm type="add" /> },
        // { ...mGroupingEditRoute, element: <MGroupingForm type="edit" /> },
        { ...mConvertionRoute, element: <MConversion /> },
        { ...mTNCRoute, element: <MTNCSetting /> },
        { ...mBankAccRoute, element: <MBankAccount /> },
        { ...mPaymentMethodRoute, element: <MPaymentMethod /> },
        { ...mProcessRoute, element: <MProcess /> },
        { ...mProcessCreateRoute, element: <MProcessForm /> },
        { ...mProcessEditRoute, element: <MProcessForm /> },
        { ...mFinanceRoute, element: <MFinanceRoom /> },
        { ...mWarehouseRoute, element: <MWarehouse /> },
        { ...mPriceTierRoute, element: <MPriceTier /> },
        { ...mWarehouseAddressCreateRoute, element: <MWarehouseAddressForm type='add' /> },
        { ...mWarehouseAddressEditRoute, element: <MWarehouseAddressForm type='edit' /> },
        { ...mWarehouseStorageRoute, element: <MWarehouseStorage /> },
    ],
};